module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salary-settings-users"
  }, [(_vm.isSalaryIntegrationActive) ? _c('SalarySettingsUsersOpus', {
    attrs: {
      "users": _vm.usersWithEmployments,
      "tags": _vm.tags,
      "employments": _vm.employments,
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
    },
    on: {
      "setTheEditUser": _vm.setTheEditUser,
      "editEmployment": _vm.setTheEditUserEmployment
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? [_c('div', {
    staticClass: "do-table__filters"
  }, [_c('div', {
    staticClass: "do-table__filters__left"
  }, [_c('Tabs', {
    staticStyle: {
      "height": "26px"
    },
    attrs: {
      "tabs": _vm.theTabs,
      "selected": _vm.theSelectedTab,
      "isLarge": false
    },
    on: {
      "select": function($event) {
        _vm.theSelectedTab = $event
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.tags,
      "selectedTags": _vm.appliedFilters,
      "numberOfSelectedTagsToShow": 6,
      "placeholder": 'Vælg grupper'
    },
    on: {
      "select": _vm.setTagFromFilter,
      "clear": _vm.clearAllTags
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "do-table__filters__add"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedUsers.length) + " af " + _vm._s(_vm.filteredUsers.length))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickAway),
      expression: "onClickAway"
    }],
    staticClass: "do-dropdown",
    class: {
      'do-dropdown--open': _vm.isDropdown
    }
  }, [(_vm.selectedUsers.length < 1) ? _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'left',
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window'
      }),
      expression: "{\n                  placement: 'left',\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n              }"
    }],
    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit do-bttn--submit--disabled",
    attrs: {
      "content": "Vælg personale først"
    }
  }, [_vm._v("\n            Tilføj ansættelser "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]) : _c('button', {
    staticClass: "do-dropdown__toggler do-bttn do-bttn--submit",
    on: {
      "click": _vm.setIsDropdown
    }
  }, [_vm._v("\n            Tilføj ansættelser "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "do-dropdown"
    }
  }, [(_vm.isDropdown) ? _c('div', {
    staticClass: "do-dropdown__dropdown"
  }, [_c('ul', [_vm._l((_vm.employmentsTypesForDropdown), function(employmentType) {
    return _c('li', {
      staticClass: "do-dropdown__dropdown__item",
      class: {
        'do-dropdown__dropdown__item--active': employmentType.v_isSelected
      },
      on: {
        "click": function($event) {
          return _vm.selectedEmploymentsType(employmentType.v_title)
        }
      }
    }, [_c('div', {
      staticClass: "do-dropdown__dropdown__item__name"
    }, [_c('span', {
      staticClass: "icon-user"
    }), _vm._v("\n                    " + _vm._s(employmentType.v_title) + "\n                  ")]), _vm._v(" "), (employmentType.v_isSelected) ? _c('div', {
      staticClass: "icon__checkmark"
    }, [_c('span', {
      staticClass: "icon-checkmark-circle"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    staticClass: "do-dropdown__dropdown__item do-dropdown__dropdown__item--add",
    on: {
      "click": function($event) {
        return _vm.setIsCreateNewEmploymentTitle(true)
      }
    }
  }, [_c('div', {
    staticClass: "btn-trans"
  }, [_vm._v("\n                    Opret ny stillingskategori\n                  ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "do-dropdown__dropdown__buttons"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
        onShow: function () { return _vm.selectedEmployments.length < 1 || _vm.selectedUsers.length < 1; }
      }),
      expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => selectedEmployments.length < 1 || selectedUsers.length < 1\n            }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    class: [{
      'do-bttn--submit--disabled': _vm.selectedEmployments.length < 1 || _vm.selectedUsers.length < 1
    }, {
      'do-bttn--submit--loading': _vm.isSubmittingUsers
    }],
    attrs: {
      "content": "Vælg personer og ansættelser først"
    },
    on: {
      "click": function($event) {
        return _vm.setIsAddExistingEmploymentsToUsers(true)
      }
    }
  }, [_vm._v("\n                  Gem\n                ")])])]) : _vm._e()])], 1)])]), _vm._v(" "), _c('table', {
    staticClass: "do-table do-table__user-employments"
  }, [_c('thead', [_c('th', {
    staticClass: "do-table__toggle-all",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.selectedUsers.length === 0) ? [_vm._v("\n          " + _vm._s(_vm.$t('vue2.tagging.select_all')) + "\n        ")] : [_vm._v("\n          " + _vm._s(_vm.$t('vue2.tagging.unselect_all')) + "\n        ")]], 2), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Stillingskategori")])]), _vm._v(" "), _c('tbody', {
    ref: "d-b"
  }, _vm._l((_vm.filteredUsers), function(user) {
    return _c('tr', {
      key: user.id,
      on: {
        "click": function($event) {
          return _vm.toggleUser(user)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "d-checkbox",
      class: {
        'd-checkbox--active': user.v_isSelected
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticClass: "d-tags"
    }, [_vm._l((user.v_employments), function(employment) {
      return _c('div', {
        staticClass: "d-tag",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.setTheEditUserEmployment({
              user: user,
              employment: employment
            })
          }
        }
      }, [_vm._v("\n            " + _vm._s(employment.title) + "\n            "), (employment.manual_salary) ? _c('div', {
        staticClass: "do-pill do-pill--small do-pill--yellow"
      }, [_vm._v("Vikarløn")]) : _vm._e()])
    }), _vm._v(" "), (user.v_employments.length === 0) ? _c('p', {
      staticClass: "italic font-small"
    }, [_vm._v("Ingen ansættelser")]) : _vm._e()], 2), _vm._v(" "), _c('td', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'\n            }"
      }],
      staticClass: "icon__bg-circle",
      attrs: {
        "content": "Redigér ansættelser"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setTheEditUser(user)
        }
      }
    }, [_c('span', {
      staticClass: "icon-wrench"
    })])])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.theEditUser) ? _c('SalarySettingsUsersUser', {
    attrs: {
      "user": _vm.theEditUser,
      "theEditEmployment": _vm.theEditUserEmployment,
      "school": _vm.school,
      "isSalaryIntegrationActive": _vm.isSalaryIntegrationActive
    },
    on: {
      "close": function($event) {
        return _vm.setTheEditUser(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAddEmploymentModal) ? _c('SalarySettingsCreateEmploymentType', {
    attrs: {
      "selectedUsers": _vm.selectedUsers,
      "isManualSalary": _vm.isManualSalary,
      "isCreateNewEmploymentTitle": _vm.isCreateNewEmploymentTitle
    },
    on: {
      "setIsManualSalary": _vm.setIsManualSalary,
      "save": _vm.saveForUsers,
      "close": function($event) {
        return _vm.setIsAddExistingEmploymentsToUsers(false)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65d22297!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsers.vue
// module id = 1968
// module chunks = 1